export const mutations = {
  SET_ACCOUNTS (state, accounts) {
    state.accounts = accounts
  }
}
